import "./index.scss"

const PageHeader = (props) => {
  const { label, size } = props
  return (
    <div className={size}>
      <div className={`header`}>
        {label}
      </div>
    </div>
  )
}

export default PageHeader